import axios from "axios";

export function updateEmail(value) {
    return {
        type: "UPDATE_PASSWORD_RECOVERY_EMAIL",
        value,
        errors: validateEmail(value)
    };
}

export function updatePassword(value) {
    return {
        type: "UPDATE_PASSWORD_RECOVERY_PASSWORD",
        value,
        errors: validatePassword(value)
    };
}

export function updatePasswordConfirmation(password, passwordConfirmation) {
    return {
        type: "UPDATE_PASSWORD_RECOVERY_PASSWORD_CONFIRMATION",
        value: passwordConfirmation,
        errors: validatePasswordConfirmation(password, passwordConfirmation)
    };
}

export function requestPasswordRecovery(email) {
    return {
        type: "REQUEST_PASSWORD_RECOVERY",
        payload: axios.post("/rest/authentication/password-recovery", {
            email
        })
    }
}

export function completePasswordRecovery(token, password) {
    return {
        type: "COMPLETE_PASSWORD_RECOVERY",
        payload: axios.post("/rest/authentication/password-recovery/" + token, {
            password
        })
    }
}

export function initPasswordRecoveryForm() {
    return {
        type: "INIT_PASSWORD_RECOVERY_FORM",
        email: "",
        emailErrors: validateEmail(""),
        password: "",
        passwordErrors: validatePassword(""),
        passwordConfirmation: "",
        passwordConfirmationErrors: validatePasswordConfirmation("")        
    }
}

export function displayValidationErrors() {
    return {
        type: "DISPLAY_PASSWORD_RECOVERY_VALIDATION_ERRORS"
    }
}

function validateEmail(value) {
    var errors = [];
    if (!value.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
        errors.push("Nieprawidłowy adres e-mail")
    }
    return errors;
}

function validatePassword(value) {
    var errors = [];
    if (value.length < 8) {
        errors.push("Hasło nie może być krótsze niż 8 znaków")
    }
    if (value.length > 40) {
        errors.push("Hasło nie może być dłuższe niż 40 znaków")
    }
    return errors;
}

function validatePasswordConfirmation(password, passwordConfirmation) {
    var errors = [];
    if (password !== passwordConfirmation) {
        errors.push("Hasła muszą być identyczne")
    }
    return errors;
}


// WEBPACK FOOTER //
// ./src/actions/passwordRecovery.js